import {
  BadgeCheck,
  Building2,
  ChartColumn,
  ClipboardCheck,
  Cpu,
  FileInput,
  FileText,
  Gauge,
  GitBranch,
  Hospital,
  LayoutDashboard,
  Library,
  ListChecks,
  MessageCircle,
  ShieldCheck,
  Shuffle,
  Smartphone,
  TrendingUp,
} from 'lucide-react';

// Icon names used in products.js -> lucide components (sai's productIcons.js).
export const PRODUCT_ICONS = {
  BadgeCheck,
  Building2,
  ChartColumn,
  ClipboardCheck,
  Cpu,
  FileInput,
  FileText,
  Gauge,
  GitBranch,
  Hospital,
  LayoutDashboard,
  Library,
  ListChecks,
  MessageCircle,
  ShieldCheck,
  Shuffle,
  Smartphone,
  TrendingUp,
};
